"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAndCombineAllRedeemedRewards = exports.getAllRedeemedRewards = void 0;
const domain_1 = require("@oolio-group/domain");
function getAllRedeemedRewards(order) {
    const orderLevelRewards = ((order === null || order === void 0 ? void 0 : order.adjustments) || []).filter(adj => adj.adjustmentType === domain_1.AdjustmentType.REWARD);
    const itemLevelRewards = ((order === null || order === void 0 ? void 0 : order.orderItems) || [])
        .map(orderItem => {
        return (orderItem.adjustments || []).filter(adj => adj.adjustmentType === domain_1.AdjustmentType.REWARD);
    })
        .flat();
    return [...orderLevelRewards, ...itemLevelRewards];
}
exports.getAllRedeemedRewards = getAllRedeemedRewards;
function getAndCombineAllRedeemedRewards(order) {
    const allRedeemedRewards = getAllRedeemedRewards(order);
    const rewardMap = allRedeemedRewards.reduce((rewardMap, redemption) => {
        var _a, _b;
        const newReward = {
            ...redemption,
            // merge identical rewards into 1 with summed quantity
            quantity: (((_a = rewardMap[redemption.id]) === null || _a === void 0 ? void 0 : _a.quantity) || 0) + redemption.quantity,
        };
        if (typeof redemption.itemQuantity === 'number') {
            // also sum item quantity if it exists
            newReward.itemQuantity =
                (((_b = rewardMap[redemption.id]) === null || _b === void 0 ? void 0 : _b.itemQuantity) || 0) + redemption.itemQuantity;
        }
        rewardMap[redemption.id] = newReward;
        return rewardMap;
    }, {});
    return Object.values(rewardMap);
}
exports.getAndCombineAllRedeemedRewards = getAndCombineAllRedeemedRewards;
//# sourceMappingURL=loyaltyRewards.js.map